import { ACCOUNT_ACTIVITY_ROUTE } from './Areas/AccountActivity/constants'
import { ACTIVITY_STATEMENTS_ROUTE } from './Areas/Account/ActivityStatements/constants'
import { BankAccountEditRoute } from './Areas/BankAccount/constants'
import { CHANGE_TEMP_PASSWORD_ROUTE } from './Areas/ChangePassword/constants'
import { KAMBI_ROOT_ROUTE } from './Areas/Kambi/constants'
import { MYSTERY_BET_ROUTE } from './Areas/MysteryBet/constants'
import { PRECOMMITMENT_ROUTE } from './Areas/Account/Precommitment/constants'
import { StructuredSearchRoute } from './Areas/StructuredSearch/constants'
import { TABLocatorWebRoute } from './Areas/TABLocatorWeb/constants'
import { TAKE_A_BREAK_ROUTE } from './Areas/Account/TakeABreak/constants'
import { SIGNUP_ROOT_ROUTE } from '@mobi/account/Areas/SignUp/Utils'
import { SHORTENED_URL_ROUTE } from '@core/Areas/ShortenedUrls/constants'
import { DEPOSIT_ROOT } from '@mobi/account/Areas/Deposit/Utils/routes'

type RoutePath = `/${string}`
type AppRoutesPath = Readonly<RoutePath | RoutePath[]>

export const AppRoutes = {
  Account: '/account',
  AccountActivity: [`/${ACCOUNT_ACTIVITY_ROUTE}/:tab`, `/${ACCOUNT_ACTIVITY_ROUTE}`],
  AccountLogout: '/account/logout',
  ActivityStatements: `/${ACTIVITY_STATEMENTS_ROUTE}`,
  BankAccountEdit: `/${BankAccountEditRoute}`,
  Biometrics: '/account/biometrics',
  Blackbook: '/account/blackbook',
  ChangePassword: '/account/change-password',
  ChangeTemporaryPassword: `/${CHANGE_TEMP_PASSWORD_ROUTE}/:accountNumber`,
  CloseAccount: '/account/close',
  ContactUs: '/contactus',
  Deposit: DEPOSIT_ROOT,
  DepositLimits: '/account/deposit-limits',
  DepositLimitsEdit: '/account/deposit-limits/edit/:depositLimitId',
  FavouriteNumbers: '/favourite-numbers',
  BetLoop: '/bet-loop',
  BetLoopProfile: '/bet-loop/profile',
  BetLoopMyProfile: '/bet-loop/my-profile',
  BetLoopMyProfileFollowList: '/bet-loop/my-profile/follow-list',
  GoodThings: '/goodthings',
  Home: '/',
  Jackpots: '/jackpots',
  MarketingCommunications: '/account/marketingcommunications',
  MarketingCommunicationsOptIn: '/account/marketingcommunications/optin',
  Meetings: '/tote',
  MysteryBet: [`/${MYSTERY_BET_ROUTE}`, `/${MYSTERY_BET_ROUTE}/:meetingId/:raceNumber`],
  NextEvents: ['/next-events', '/tote/nextevents'],
  Offers: '/account/offer',
  Precommitment: `/${PRECOMMITMENT_ROUTE}`,
  RaceCard: '/tote/meetings/:meetingId/:raceNumber',
  RaceCardFixedOnly: '/fobracing/propositions/:product/:code/:raceId/:selectiondate?',
  RaceCardSky: '/live-sky-race',
  RaceEvents: '/fobracing/:product/:code/:date?',
  RaceList: ['/tote/meetings/:meetingId', '/tote/races'],
  Settings: '/account/settings',
  SettingsMFA: '/account/settings/mfa',
  SignUp: `/${SIGNUP_ROOT_ROUTE}`,
  Specials: '/specials',
  Sports: '/sports',
  SportsRoot: `/${KAMBI_ROOT_ROUTE}`,
  StructuredSearch: `/${StructuredSearchRoute}`,
  ShortenedUrls: `/${SHORTENED_URL_ROUTE}`,
  TABLocatorWeb: `/${TABLocatorWebRoute}`,
  TakeABreak: `/${TAKE_A_BREAK_ROUTE}`,
  Tipping: '/totesports',
  Toolbox: '/toolbox',
  VenueMode: '/venue-mode',
} as const

export const RACES_ROUTES: AppRoutesPath[] = [
  AppRoutes.AccountActivity,
  AppRoutes.Blackbook,
  AppRoutes.RaceCardFixedOnly,
  AppRoutes.FavouriteNumbers,
  AppRoutes.Jackpots,
  AppRoutes.Meetings,
  AppRoutes.MysteryBet,
  AppRoutes.NextEvents,
  AppRoutes.Offers,
  AppRoutes.RaceEvents,
  AppRoutes.RaceList,
  AppRoutes.Specials,
  AppRoutes.StructuredSearch,
  AppRoutes.Tipping,
  // Non-react route
  '/goodthings',
]
